<script lang="ts" setup>
import { ref } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import { MessageService } from '~/services/message.service';
import { timeSweetFormat2 } from '~/utils/dayjs';
import HTNotificationTitle from './HTNotificationTitle.vue';

defineOptions({
  inheritAttrs: false,
});

const conRef = ref();
const service = useService(MessageService);

const popoverStyle: any = {
  maxHeight: '512px',
  overflowY: 'auto',
};
</script>

<template>
  <div ref="conRef">
    <a-popover
      placement="bottomRight"
      trigger="click"
      :overlay-inner-style="popoverStyle"
      :get-popup-container="() => conRef"
      :align="{
        offset: [0, 5],
      }"
      @open-change="service.handleOpenChange"
    >
      <div
        v-track:oj_notification_icon_click.click
        class="h-6 w-6 cursor-pointer rounded-sm hover:bg-[#E8F3FF]"
      >
        <a-badge :dot="service.showDot" :offset="[-3, 3]">
          <img
            class="h-6 w-6"
            src="~/assets/image/icon/icon-notification.svg"
            alt="icon"
          />
        </a-badge>
      </div>

      <template #content>
        <div class="w-[340px] p-2">
          <div v-if="service.list.length === 0">
            <div
              class="flex h-32 items-center justify-center text-base text-[#ccc]"
            >
              暂无消息
            </div>
          </div>
          <ul>
            <li
              v-for="item in service.list"
              :key="item.id"
              v-track:element_show="service.getMsgShowEvent(item)"
              class="mb-4 flex cursor-pointer items-center justify-between gap-4 border-b border-[#F1F1F1] pb-4 text-title last:mb-0 last:border-none last:pb-0"
              @click="service.handleClickMessage(item)"
            >
              <div class="w-0 flex-1">
                <HTNotificationTitle :msg="item" />
                <div class="truncate text-subtitle">
                  {{ item.posterName }}
                </div>
              </div>
              <div class="w-[84px] flex-shrink-0 text-right text-subtitle">
                {{ timeSweetFormat2(item.messageTime as number) }}
              </div>
            </li>
          </ul>
        </div>
      </template>
    </a-popover>
  </div>
</template>

<style scoped></style>
